import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import ColorOptionTitle from '../customiseOptionTitle/ColorOptionTitle';
import ColorOptionsList from '../../../../../../../gqlCommon/components/colorOptionsList/ColorOptionsList';
import { useSelectedColorFeatures } from '../../../../../../hooks/features/useSelectedColorFeatures';
import IFeaturesList from '../../../../../../model/IFeaturesList';

export interface IColorOptionsListProps {
  featuresList: IFeaturesList;
}

const CustomiseColorOptionsList: FC<IColorOptionsListProps> = ({ featuresList }) => {
  const { colorSelectionCode, colorSelectionName, handleColorSelection } = useSelectedColorFeatures(featuresList);

  return (
    <Box display="flex" flexDirection="column">
      <ColorOptionTitle title={colorSelectionName} featureId={colorSelectionCode} />
      <ColorOptionsList
        features={featuresList.features}
        onClick={handleColorSelection}
        selectedCode={colorSelectionCode}
      />
    </Box>
  );
};

export default CustomiseColorOptionsList;
